export default class User {
  constructor(username, email, password, role, enabled) {
    this.username = username;
    this.email = email;
    this.password = password;
    this.role = role;
    this.enabled = enabled;
  }
}
